const CustomFilter = _ref => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref;
  return searchFilter.renderCustomFilterCallback({
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  });
};
export default CustomFilter;